<template>
  <div class="hiddenManage">
    <tree-box title="隐患配置" @sendID="getID" showTree>
      <template slot="message">
        <h3>隐患列表</h3>
        <div class="table">
          <el-table v-loading="loading" :data="tableList">
            <el-table-column
              width="80"
              prop="id"
              align="center"
              label="序号"
            ></el-table-column>
            <el-table-column
              prop="riskLevelName"
              align="center"
              label="隐患等级"
            ></el-table-column>
            <el-table-column prop="riskName" label="隐患类型"></el-table-column>
            <el-table-column
              prop="updateTime"
              label="编辑时间"
            ></el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <span class="tableBtn" @click="showDialog(scope.row)"
                  >编辑</span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!--        <div v-if="!deptId" class="tip">-->
        <!--          <img src="../img/jiantou.png" /><span style="margin-left: 12px"-->
        <!--            >请点击右侧选择单位</span-->
        <!--          >-->
        <!--        </div>-->
      </template>
    </tree-box>

    <el-dialog
      title="编辑隐患等级"
      width="30%"
      :visible.sync="dialog"
      class="dialog"
      :close-on-click-modal="false"
    >
      <label><em style="color: rgba(254, 109, 138, 1)">*</em>隐患等级</label>
      <el-select v-model="level" size="large">
        <el-option
          v-for="item in riskLevel"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmEdit">确 定</el-button>
        <el-button @click="dialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Axios from "../../../utils/Axios";
import treeBox from "./components/treeBox";
export default {
  name: "hiddenManger",
  components: { treeBox },
  data() {
    return {
      riskLevel: [],

      id: null,
      level: null,
      deptId: 15,
      tableList: [],
      loading: false,
      dialog: false,
    };
  },
  methods: {
    getID(id) {
      this.deptId = id;
      this.queryTableList();
    },
    showDialog(row) {
      this.dialog = true;
      this.id = row.id;
      this.level = row.riskLevel;
      this.queryRiskLevels();
    },
    confirmEdit() {
      Axios.ajax({
        url: "/riskManage/edit",
        method: "post",
        data: {
          id: this.id,
          riskLevel: this.level,
        },
      }).then((res) => {
        if (res.resultCode == 0) {
          this.$message.success("修改成功！");
        } else {
          this.$message.warning("修改失败！");
        }

        this.dialog = false;
        this.queryTableList();
      });
    },
    queryTableList() {
      this.loading = true;
      const params = {
        url: "/riskManage/list",
        method: "post",
        data: {
          deptId: this.deptId,
        },
      };
      Axios.ajax(params).then(({ data }) => {
        this.loading = false;
        this.tableList = data;
      });
    },

    queryRiskLevels() {
      Axios.ajax({
        url: "/riskManage/allRiskLevels",
        method: "get",
      }).then(({ data }) => {
        this.riskLevel = data.map((item) => {
          return {
            label: item.levelName,
            value: item.sysRiskLevel,
          };
        });
      });
    },
  },
  mounted() {
    this.queryTableList();
  },
};
</script>

<style lang="less" scoped>
.hiddenManage {
  .message {
    h3 {
      padding: 0 10px;
      border-left: 2px solid #2a62ff;
    }
    .table {
      height: 90%;
      overflow: auto;
      padding-top: 32px;
      .tableBtn {
        cursor: pointer;
        color: #2a62ff;
      }
    }
    .tip {
      width: 100%;
      text-align: center;
      padding: 20%;
      color: #7d879f;
      font-size: 16px;
    }
    .btn-group {
      margin-top: 44px;
    }
    .btn-group button:first-child {
      margin-right: 40px !important;
    }
  }
  .dialog {
    font-size: 14px;
    text-align: center;
    label {
      margin-right: 12px;
    }
  }
}
</style>
